module.exports = __webpack_public_path__ + "static/media/bike.b5631fc5.png";